export const AppRoutes = {
    callback: '/callback',
    loggedOut: '/logged-out',
    home: '/home',
    referralForm: '/referral-form',
    referralHistory: '/referral-history',
    referralDetails: (id = ':id') => `/referral-history/${id}`,
    termsAndConditions: '/terms-and-conditions',
    termsOfUse: '/terms-of-use',
    privacyPolicy: '/privacy-policy',
    updatesHistory: '/updates-history',
};
